import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link, Grid, Hidden, Typography } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Banner from "./Banner";
import MenuContainer from "../menu/MenuContainer";
import { MenuProvider } from "../menu/MenuContext";
import { colors } from "../../theme";
import { LanguageSelection } from "../language/LanguageSelection";

const useStyles = makeStyles((theme) => ({
  header: {
    borderBottom: "2px solid" + colors.BORDER,
  },
  logo: {
    height: "70px",
    margin: "12px 0px 4px 4px",
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "15px",
    },
  },
  menu: {
    textAlign: "right",
    marginTop: "15px",
  },
  statementTitle: {
    marginTop: "15px",
    paddingTop: "12px",
    color: colors.BUTTON_BG,
    fontSize: "32px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.08px",
    [theme.breakpoints.down('sm')]: {
      paddingLeft: "15px",
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: "24px",
    },
  },
}));

const debugColor = "";

export default function Header({ title }: { title?: string }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Grid container item sm={12} className={classes.header}>
        <Hidden mdDown>
          <Grid item lg={1} style={{ backgroundColor: debugColor }} />
        </Hidden>
        <Grid item xs={6} lg={5}>
          <div>
            <Link component={RouterLink} to="/">
              <Typography component="h1" className={classes.statementTitle}>
              {t("header.dashboard")}
              </Typography>
            </Link>
          </div>
        </Grid>
        <Grid
          container
          item
          direction="row"
          justify="flex-end"
          alignItems="center"
          xs={6}
          lg={5}
          className={classes.menu}
        >
          <Grid item>
            <LanguageSelection />
          </Grid>
          <Grid item>
            <MenuProvider>
              <MenuContainer />
            </MenuProvider>
          </Grid>
        </Grid>
        <Hidden mdDown>
          <Grid item lg={1} style={{ backgroundColor: debugColor }} />
        </Hidden>
      </Grid>

      {title && <Banner title={title} />}
    </>
  );
}
